// CookieOptions 타입을 직접 정의하여 hono 의존성 문제 해결
interface CookieOptions {
  httpOnly?: boolean
  secure?: boolean
  sameSite?: 'strict' | 'lax' | 'none'
  maxAge?: number
  expires?: Date
  path?: string
  domain?: string
}

export const ACCESS_TOKEN_KEY = 'accessToken' as const
export const REFRESH_TOKEN_KEY = 'refreshToken' as const

export const ACCESS_TOKEN_EXPIRE_SECONDS = 86_400 // 1 day
export const REFRESH_TOKEN_EXPIRE_SECONDS = 7_776_000 // 90 days
export const THIRTY_DAYS_IN_SECONDS = 3600 * 24 * 30 // 30일을 초로 변환
export const ONE_YEAR_IN_SECONDS = 3600 * 24 * 365 // 1년을 초로 변환
export const COOKIE_MAX_AGE_LIMIT_SECONDS = 400 * 24 * 60 * 60

export const toCookieMaxAgeSeconds = (expiresIn: number) => {
  const normalizedExpiresIn = expiresIn > COOKIE_MAX_AGE_LIMIT_SECONDS ? Math.floor(expiresIn / 1000) : expiresIn

  return Math.min(normalizedExpiresIn, COOKIE_MAX_AGE_LIMIT_SECONDS)
}

export const COOKIE_KEYS = {
  BEARER_TOKEN: 'authorization',
  ACCESS_TOKEN: 'accessToken',
  OAUTH_PROVIDER_NAME: 'oauthProviderName',
  OAUTH_PROVIDER_ACCESS_TOKEN: 'oauthProviderAccessToken',
  OAUTH_PROVIDER_REFRESH_TOKEN: 'oauthProviderRefreshToken',
  REFRESH_TOKEN: 'refreshToken',
  USER_UID: 'uid',
  USER_TOKEN: 'token',
  FROM: 'from',
  /**
   * @deprecated please use oauthProviderName instead
   */
  FROM_APPLE_LOGIN: 'from_apple_login',
  SESSION_ID: 'sessionId',
} as const

export const FROM_COOKIE_OPTIONS = {
  httpOnly: true,
  // sameSite: 'strict',
  secure: true,
} as const satisfies CookieOptions

export const BEARER_TOKEN_COOKIE_OPTIONS = {
  httpOnly: true,
  // sameSite: 'strict',
  secure: true,
  maxAge: ACCESS_TOKEN_EXPIRE_SECONDS,
} as const satisfies CookieOptions

export const APP_TOKEN_COOKIE_OPTIONS = {
  httpOnly: true,
  // sameSite: 'strict',
  secure: true,
  maxAge: ONE_YEAR_IN_SECONDS,
} as const satisfies CookieOptions

export const ACCESS_TOKEN_COOKIE_OPTIONS = {
  httpOnly: true,
  // sameSite: 'strict',
  secure: true,
  maxAge: ACCESS_TOKEN_EXPIRE_SECONDS,
} as const satisfies CookieOptions

export const REFRESH_TOKEN_COOKIE_OPTIONS = {
  httpOnly: true,
  // sameSite: 'strict',
  secure: true,
  maxAge: REFRESH_TOKEN_EXPIRE_SECONDS,
} as const satisfies CookieOptions

export const USER_UID_COOKIE_OPTIONS = {
  httpOnly: true,
  // sameSite: 'strict',
  secure: true,
  maxAge: THIRTY_DAYS_IN_SECONDS,
} as const satisfies CookieOptions

export const USER_TOKEN_COOKIE_OPTIONS = {
  httpOnly: true,
  // sameSite: 'strict',
  secure: true,
  maxAge: THIRTY_DAYS_IN_SECONDS,
} as const satisfies CookieOptions

/**
 * @deprecated please use oauthProviderName instead
 */
export const FROM_APPLE_LOGIN_COOKIE_OPTIONS = {
  httpOnly: true,
  // sameSite: 'strict',
  secure: true,
  maxAge: THIRTY_DAYS_IN_SECONDS,
} as const satisfies CookieOptions
